<template>
    <ul class="work_list d-flex flex-wrap" :class="{'available-animate': availableAnimate}">
        <li v-for="work in filteredWorks" :key="work.id" v-animate="'slide-in-up'">
            <a :href="work.link+'?id='+work.id" class="work_anchor">
                <div class="work_area">
                    <div class="work_image">
                        <img :src="work.logo" :alt="work.title" class="image">
                    </div>
                    <div class="work_logo" v-if="work.logo_bottom">
                        <img :src="work.logo_bottom" :alt="work.title" class="image">
                    </div>
                    <div class="middle"></div>
                </div>
                <div class="work_column d-flex">
                    <p class="work_title fw-bold" v-html="work.subtitle"></p>
                    <ul class="country_list d-flex">
                        <li>
                            <img :src="`${work.country}`" :alt="`${work.country}`" class="image">
                        </li>
                    </ul>
                </div>
                <p class="work_text" v-html="work.title"></p>
                <ul class="category_list d-flex">
                    <li v-for="category in work.categories" :key="category.id">{{ category }}</li>
                </ul>
            </a>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'WorksItem',
    props: {
        filter: String,
        availableAnimate: Boolean
    },
    data() {
        return {
            works: [],
            category: null
        }
    },
    created() {
        this.axios.get('/global-works/works.json').then( res => {
            for(let i=0; i<res.data.length; i++) {
                res.data[i].cate = res.data[i].country
                let img = res.data[i].country + "-flag.svg"
                res.data[i].country = require("@/assets/works/" + img)
                this.works.push(res.data[i])
            }
        })   
    },
    computed: {
        filteredWorks () {
            return this.works.filter(work => {
                switch (this.filter) {
                    case '日本':
                        this.category ='JP';
                        break;
                    case '中国':
                        this.category ='CN';
                        break;
                    case '英国':
                        this.category ='EN';
                        break;
                    case '台湾':
                        this.category ='TW';
                        break;
                    case 'マレーシア':
                        this.category ='MA';
                        break;
                    case 'ベトナム':
                        this.category ='VN';
                        break;
                    case 'タイ':
                        this.category ='TH';
                        break;
                    case 'シンガポール':
                        this.category ='SP';
                        break;
                    default: 
                        this.category =this.filter;
                }
                return this.category == '' || work.categories.some(cat => cat === this.category) || (work.cate === this.category);
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    @keyframes slide-in-up {
        0% {
            visibility: visible;
            opacity: 0;
            transform: translate3d(0,20%,0);
        }

        to {
            visibility: visible;
            opacity: 1;
            transform: translateZ(0);
        }
    }

    .animate {
        visibility: hidden;
    }

    .available-animate {
        .animate-active.slide-in-up {
            animation: slide-in-up .7s ease-out;
            animation-fill-mode: forwards;
        }

        .animate-active {
            &:nth-child(2n+1) {
                animation-delay: 0s;
            }
            &:nth-child(2n) {
                animation-delay: .7s;
            }
        }
    }

    .work_list {
        justify-content: space-between;
        margin-bottom: 0;
        padding-left: 0;
        > li {
            list-style: none;
            width: 46%;
            border-bottom: 2px solid #eeeeee;
            padding-bottom: 69px;
            transition: border-color .3s ease-in-out;
            &:nth-child(n+3) {
                margin-top: 101px;
            }
            &:hover {
                border-bottom: 2px solid #f2aa00;
            }
        }
    }

    .image {
        width: 100%;
        height: auto;
    }

    .work_area {
        position: relative;
        margin-bottom: 49px;
    }

    .work_logo {
        position: absolute;
        bottom: -30px;
        left: 0;
        width: 23.1%;
        z-index: 1;
    }

    .work_title {
        font-size: 20px;
        margin-bottom: 20px;
        width: calc(100% - 35px);
    }

    .work_text {
        line-height: 1.875;
    }

    .work_column {
        justify-content: space-between;
    }

    .country_list {
        width: 28px;
        justify-content: flex-end;
        padding-left: 0;
        > li {
            list-style: none;
            &:not(:last-child) {
                margin-right: 15px;
            }
        }
    }

    .category_list {
        padding-left: 0;
        > li {
            list-style: none;
            font-size: 14px;
            line-height: 1.2;
            padding: 2px 10px 3px 10px;
            border: 1px solid #000000;
            &:not(:last-child) {
                margin-right: 10px;
            }
        }
    }

    .work_image {
        overflow: hidden;
        .image {
            transition: all .3s;
        }
    }

    .work_anchor {
        &:hover {
            color: #000000;
            .work_image .image {
                transform: scale(1.1);
            }

            .middle {
                opacity: 1;
                background: rgba(0, 0, 0, 0.2);
            }
        }
    }

    @media screen and (max-width: 767px) {
        .work_list {
            flex-wrap: wrap;
            > li {
                width: 100%;

                &:nth-child(n+3) {
                    margin-top: 0;
                }

                &:not(:last-child) {
                    margin-bottom: 70px;
                }
            }
        }
        .available-animate {
            .animate-active {
                &:nth-child(2n) {
                    animation-delay: 0s;
                }
            }
        }
    }
</style>
